/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CumulativeReportEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const cumulativeReportEntrypoint: EntryPoint<CumulativeReportEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<CumulativeReportEntrypointComponent>(
			/* webpackChunkName: "async-next-gen-reports-cumulative-entrypoint" */ './index.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
